import { produce } from 'immer';
import { createJSONStorage } from 'zustand/middleware';

import { Language } from '@bcp-channels-sharedcomponents-reactjs/core/dist/types';
import { StoreHelper } from '@helpers';

export interface SearchParamsState {
	responseType?: string;
	clientId?: string;
	redirectUri?: string;
	codeChallenge?: string;
	codeChallengeMethod?: string;
	scope?: string;
	state?: string;
	language?: Language;
	epoch?: string;
	fallbackUri?: string;
	k?: string;
	sf?: string;
}

export const initialSearchParamsState: SearchParamsState = {};

interface UseSearchParamsStoreOutput extends SearchParamsState {
	setState: (state: SearchParamsState) => void;
}

export const useSearchParamsStore = StoreHelper.createStore<UseSearchParamsStoreOutput>(
	(set) => ({
		...initialSearchParamsState,
		setState: function (state: SearchParamsState) {
			set(
				produce((currentState: SearchParamsState) => ({
					...currentState,
					...state,
				})),
				false,
				'setState'
			);
		},
	}),
	{
		name: 'SearchParams',
		storage: createJSONStorage(() => sessionStorage),
	}
);
